module.exports = __webpack_public_path__ + "static/banner-guillaume-mobile-53ffe01bfb54c49f5968fbb1bb3d93ce.jpg";